import generateStudyPlan from "../utils/generateStudyPlan";
import enrichDayItems from "../utils/enrichDayItems";

export function computeStudyPlan(dispatch, { lessons, levels, lessonsUsers, studyGoal, courseId, userId }) {
  if (!studyGoal?.id) {
    dispatch({ type: "STUDY_PLAN_CLEARED" });
    return;
  }

  const data = generateStudyPlan({ lessons, levels, lessonsUsers, studyGoal, courseId, userId });

  if (data.error) {
    dispatch({ type: "STUDY_PLAN_CLEARED" });
    return;
  }

  const enrichedDays = {};
  data.days.forEach((day, index) => {
    enrichedDays[index] = enrichDayItems(day.lessons || [], lessons);
  });

  const lastDay = data.days[data.days.length - 1];
  let completionDate = null;
  if (lastDay?.date) {
    completionDate = lastDay.date;
  }

  dispatch({
    type: "STUDY_PLAN_COMPUTED",
    payload: { ...data, enrichedDays, completionDate, courseId },
  });
}
